import React from "react";
import moment from "moment";

export default function DatePickerMobile(props) {
  return (
    <div className="mobile-calendar">
      <table className="table tableFixHead table-responsive-md ">
        <thead className="table-counselor-head text-center">
          <tr>
            
            {props.day.map((v, i) => {
              return (
                <th key={i}>
                  <div className="tableDay">{v.mobile}</div>
                </th>
              );
            })}
            
          </tr>
        </thead>
        <tbody>
          <tr>
            
            {props.date.map((v, i) => {
              return (
                <td className="mobile-tableDate" key={i}>
                  <div className="mobile-table-date-div" onClick={() => props.onDateClicked(v, i)}>
                    <span className={v.clicked ? "mobile-month-day-span-selected" : "mobile-month-day-span"}>{v.date.replace(/\D/g, "")}</span>
                  </div>
                </td>
              );
            })}
            
          </tr>
          {props.array[0].map((time, u) => {
            return (
              <tr className="counselor-tr" key={u} onClick={e => props.selected_date && props.handleChange(time.hour, u)}>
                <td>
                  <div className="date-picker-hour-label">{moment(time.hour).format("hh:mm A")}</div>
                </td>
                {props.array.map((v, i) => {
                  return (
                    <td key={i}>
                      <div className={time.selected ? "mobile-counsellor-hour-selected":"mobile-counsellor-hour-pick"} key={i}>
                        <div style={props.isSlotSelected(false)}>
                          <span style={v[u].disabled || v[u].selected  ? { visibility: "visible" } : { visibility: "hidden" }}>
                            {""}
                            {v[u].project ? v[u].project : moment(v[u].hour).format("hh:mm A")}
                          </span>
                        </div>
                      </div>
                    </td>
                  );
                })}
               
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/CounselorDatePicker/DatePickerMobile.js